import PageHero from "@/components/layout/PageHero";
import WorkWithUs from "@/components/sections/WorkWithUs";

const TrabalheConosco = () => (
  <>
    <PageHero
      eyebrow="Venha crescer conosco"
      title="Trabalhe Conosco"
      description="Quer crescer no mercado gráfico? Estamos sempre em busca de profissionais talentosos e comprometidos."
    />
    <WorkWithUs showHeading={false} />
  </>
);

export default TrabalheConosco;
